(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size' || this.getAttribute('data-sticky-type') === 'attachment';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orima-media"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('orima-media-player')) {
    customElements.define('orima-media-player', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video || this.observer) return;
        this.video.muted = true;
        this.visible = false;
        this.manuallyPaused = false;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.onPause = () => {
          if (this.visible && !document.hidden && !this.motion.matches) this.manuallyPaused = true;
        };
        this.onPlay = () => { this.manuallyPaused = false; };
        this.update = () => {
          if (!this.video) return;
          if (this.visible && !this.motion.matches && !document.hidden && !this.manuallyPaused) {
            const promise = this.video.play();
            if (promise) promise.catch(() => {});
          } else if (!this.visible || document.hidden || this.motion.matches) {
            this.video.pause();
          }
        };
        this.onVisibility = () => this.update();
        this.video.addEventListener('pause', this.onPause);
        this.video.addEventListener('play', this.onPlay);
        document.addEventListener('visibilitychange', this.onVisibility);
        this.motion.addEventListener('change', this.update);
        this.observer = new IntersectionObserver((entries) => {
          this.visible = entries[0].isIntersecting;
          this.update();
        }, { threshold:0.35 });
        this.observer.observe(this);
      }
      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        this.observer = null;
        document.removeEventListener('visibilitychange', this.onVisibility);
        if (this.motion) this.motion.removeEventListener('change', this.update);
        if (this.video) {
          this.video.removeEventListener('pause', this.onPause);
          this.video.removeEventListener('play', this.onPlay);
          this.video.pause();
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orima-obd-selector"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('orima-obd-selector')) {
    customElements.define('orima-obd-selector', class extends HTMLElement {
      connectedCallback() {
        if (!this.initialized) {
          this.tabs = Array.from(this.querySelectorAll('[data-obd-tab]'));
          this.panels = Array.from(this.querySelectorAll('[data-obd-panel]'));
          this.tablist = this.querySelector('[data-obd-tabs]');
          if (!this.tabs.length || this.tabs.length !== this.panels.length) return;
          this.tablist.setAttribute('role', 'tablist');
          this.tabs.forEach((tab) => {
            tab.setAttribute('role', 'tab');
            tab.setAttribute('aria-controls', tab.dataset.obdTarget);
            tab.addEventListener('click', (event) => {
              event.preventDefault();
              this.select(tab, false);
            });
            tab.addEventListener('keydown', (event) => {
              const index = this.tabs.indexOf(tab);
              let next;
              if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
              if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
              if (event.key === 'Home') next = 0;
              if (event.key === 'End') next = this.tabs.length - 1;
              if (event.key === ' ') next = index;
              if (next === undefined) return;
              event.preventDefault();
              this.select(this.tabs[next], true);
            });
          });
          this.panels.forEach((panel, index) => {
            panel.setAttribute('role', 'tabpanel');
            panel.setAttribute('aria-labelledby', this.tabs[index].id);
            panel.setAttribute('tabindex', '0');
          });
          this.select(this.tabs.find((tab) => '#' + tab.dataset.obdTarget === window.location.hash) || this.tabs[0], false);
          this.setAttribute('data-enhanced', '');
          this.onBlockSelect = (event) => {
            if (!this.contains(event.target)) return;
            const panel = event.target.closest('[data-obd-panel]');
            if (!panel) return;
            const tab = this.tabs.find((item) => item.dataset.obdTarget === panel.id);
            if (tab) this.select(tab, false);
          };
          this.initialized = true;
        }
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }
      disconnectedCallback() {
        if (this.onBlockSelect) document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }
      select(activeTab, focus) {
        this.tabs.forEach((tab) => {
          const selected = tab === activeTab;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
        });
        this.panels.forEach((panel) => {
          panel.hidden = panel.id !== activeTab.dataset.obdTarget;
        });
        if (focus) {
          activeTab.focus({ preventScroll: true });
          const tabBounds = activeTab.getBoundingClientRect();
          const listBounds = this.tablist.getBoundingClientRect();
          if (tabBounds.left < listBounds.left) this.tablist.scrollLeft -= listBounds.left - tabBounds.left;
          if (tabBounds.right > listBounds.right) this.tablist.scrollLeft += tabBounds.right - listBounds.right;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orima-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('orima-showcase')) {
    customElements.define('orima-showcase', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.track = this.querySelector('[data-track]');
        if (!this.track) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const controls = this.querySelector('[data-controls]');
        const previous = this.querySelector('[data-previous]');
        const next = this.querySelector('[data-next]');
        const update = () => {
          const maximum = this.track.scrollWidth - this.track.clientWidth;
          const position = Math.abs(this.track.scrollLeft);
          controls.hidden = maximum < 2;
          previous.disabled = position < 2;
          next.disabled = position >= maximum - 2;
        };
        const move = (direction) => {
          const styles = getComputedStyle(this.track);
          const gap = parseFloat(styles.columnGap) || 0;
          const amount = this.track.clientWidth + gap;
          const orientation = styles.direction === 'rtl' ? -1 : 1;
          this.track.scrollBy({
            left: amount * direction * orientation,
            behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
          });
        };
        previous.addEventListener('click', () => move(-1), { signal });
        next.addEventListener('click', () => move(1), { signal });
        this.track.addEventListener('scroll', update, { passive: true, signal });
        this.observer = new ResizeObserver(update);
        this.observer.observe(this.track);
        update();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
